// Types
import type { TApiHttpClientRequestConfig } from '~/misc/resource/types';
import type {
  ICompanySourceModel,
  TCompanySource,
  TCompanySourceListResponse,
  TCompanySourcePaginatedListPayload,
  TPaginatedCompanySource,
  TSourcePayload,
} from '~/shared/source/types';

// Models
import { ManagerResource } from '~/modules/manager/resource/manager-resource.model';

export class ManagerCompanySourcesModel extends ManagerResource implements ICompanySourceModel {
  list(
    companyId: number,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TCompanySourceListResponse> {
    return this.get(`companies/${companyId}/sources`, undefined, requestConfig);
  }

  paginatedList(
    companyId: number,
    payload?: TCompanySourcePaginatedListPayload,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TPaginatedCompanySource> {
    return this.get(`companies/${companyId}/sources`, { paginate: 1, ...payload }, requestConfig);
  }

  destroy(sourceId: number, requestConfig?: TApiHttpClientRequestConfig): Promise<void> {
    return this.delete(`sources/${sourceId}`, undefined, requestConfig);
  }

  create(
    companyId: number,
    payload: TSourcePayload,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TCompanySource> {
    return this.post(`companies/${companyId}/sources`, payload, requestConfig);
  }

  update(
    sourceId: number,
    payload: TSourcePayload,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TCompanySource> {
    return this.patch(`sources/${sourceId}`, payload, requestConfig);
  }
}
